import './api/axiosConfig';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// === CONTEXT IMPORTS ===
import { AuthProvider } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';
import { TaskProvider } from "./context/TaskContext";
import { ResourceProvider } from "./context/ResourceContext"; // Legacy support
import { BudgetProvider } from "./context/BudgetContext";
import { VendorProvider } from "./context/VendorContext";
import { ProcurementProvider } from './context/ProcurementContext';
import { EmployeeProvider } from './context/EmployeeContext';
import { InventoryProvider } from "./context/InventoryContext";
import { EquipmentProvider } from "./context/EquipmentContext"; // Legacy support
import { DocumentProvider } from './context/DocumentContext';
import { ComplianceProvider } from './context/ComplianceContext';
import { PurchaseOrderProvider } from './context/PurchaseOrderContext';
import { ConsumptionProvider } from './context/ConsumptionContext';
import { TimesheetProvider } from './context/TimesheetContext';
import { CostSheetProvider } from './context/CostSheetContext';
import { RequisitionProvider } from './context/RequisitionContext';
import { DailyLogProvider } from './context/DailyLogContext';
import { InternalPickingProvider } from "./context/InternalPickingContext";
import { UnitProvider } from "./context/UnitContext";
import { CRMProvider } from './context/CRMContext';
import { RoleProvider } from './context/RoleContext';
import { UserProvider } from './context/UserContext';
import { AccountingProvider } from './context/AccountingContext';
import { SettingsProvider } from './context/SettingsContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { RBACProvider } from './context/RBACContext';
import { NotificationProvider } from './context/NotificationContext';

// 🟢 NEW CONTEXTS
import { WorkforceProvider } from "./context/WorkforceContext";
import { AssetProvider } from "./context/AssetContext";
import { SubscriptionProvider } from './context/SubscriptionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <SubscriptionProvider>
    <NotificationProvider>
    <SettingsProvider>
      <CurrencyProvider>
        <RBACProvider>
          <RoleProvider>
            <UserProvider>
              <ProjectProvider>
                <CostSheetProvider>
                  <CRMProvider>
                    <TaskProvider>
                      <TimesheetProvider>

                        {/* 🟢 WRAPPING: New & Old Providers */}
                        <WorkforceProvider>
                          <AssetProvider>
                            <AccountingProvider>
                              <ResourceProvider>
                                <EquipmentProvider>

                                  <BudgetProvider>
                                    <VendorProvider>
                                      <InventoryProvider>
                                        <RequisitionProvider>
                                          <ConsumptionProvider>
                                            <ProcurementProvider>
                                              <EmployeeProvider>
                                                <DocumentProvider>
                                                  <ComplianceProvider>
                                                    <PurchaseOrderProvider>
                                                      <DailyLogProvider>
                                                        <InternalPickingProvider>
                                                          <UnitProvider>

                                                            <App />

                                                          </UnitProvider>
                                                        </InternalPickingProvider>
                                                      </DailyLogProvider>
                                                    </PurchaseOrderProvider>
                                                  </ComplianceProvider>
                                                </DocumentProvider>
                                              </EmployeeProvider>
                                            </ProcurementProvider>
                                          </ConsumptionProvider>
                                        </RequisitionProvider>
                                      </InventoryProvider>
                                    </VendorProvider>
                                  </BudgetProvider>

                                </EquipmentProvider>
                              </ResourceProvider>
                            </AccountingProvider>
                          </AssetProvider>
                        </WorkforceProvider>

                      </TimesheetProvider>
                    </TaskProvider>
                  </CRMProvider>
                </CostSheetProvider>
              </ProjectProvider>
            </UserProvider>
          </RoleProvider>
        </RBACProvider>
      </CurrencyProvider>
    </SettingsProvider>
    </NotificationProvider>
    </SubscriptionProvider>
  </AuthProvider>
);

reportWebVitals();